import { render, staticRenderFns } from "./BillOfLading.vue?vue&type=template&id=37a9e0be&"
import script from "./BillOfLading.vue?vue&type=script&lang=ts&"
export * from "./BillOfLading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports